import { render } from "./RecapSearch.component.vue?vue&type=template&id=2f4b2a14"
import script from "./RecapSearch.component.vue?vue&type=script&lang=js"
export * from "./RecapSearch.component.vue?vue&type=script&lang=js"

import "./RecapSearch.component.vue?vue&type=style&index=0&id=2f4b2a14&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__